import { useCallback } from 'react'
import { BackHandler } from 'react-native'

import { useFocusEffect, useRoute } from '@react-navigation/native'

import { useGetApplicationDetails } from './api/applicationDetails/hook'
import BrandScreens from './brandScreens'
import { brandsI18n } from './localization'
import { LinkBroken } from './modules/common/linkBroken'
import Loader from './modules/loadingScreen/loader'
import { stateMap } from './utils/stateMap'

const BrandsCC = () => {
  const { params = {} } = useRoute()
  const { hash } = params

  const { data, isFetching, isError } = useGetApplicationDetails(hash)

  const isValidPartnerId = Boolean(stateMap[data?.partnerId])

  useFocusEffect(
    useCallback(() => {
      const onBackPress = () => {
        return true
      }

      const subscription = BackHandler.addEventListener(
        'hardwareBackPress',
        onBackPress
      )

      return () => subscription.remove()
    }, [])
  )

  if (isFetching) {
    return <Loader subTitle={brandsI18n.t('common.checkingEligibility')} />
  }

  if (!hash || isError || !data || !isValidPartnerId) {
    return <LinkBroken />
  }

  return <BrandScreens applicationDetails={data} />
}

export default BrandsCC
